"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let InvoiceReferenceSearch = class InvoiceReferenceSearch extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
        this.$$cache_selectedReferenceType = new core_1.ComponentValueCache(this, "selectedReferenceType", "InvoiceReferenceSearchModal.selectedReferenceType");
    }
    onReferenceSelected(...args) {
        const { option, value } = args[0];
        if (option) {
            this.selectedItems.push(option);
            if (option.rental_id && option.rental_name) {
                this.selectedItems.push({
                    object: 'rental',
                    id: option.rental_id,
                    name: option.rental_name
                });
            }
            if (option.client_id && option.client_name) {
                this.selectedItems.push({
                    object: 'company',
                    id: option.client_id,
                    name: option.client_name
                });
            }
            if (option.properties) {
                _.each(option.properties, p => {
                    if (p.object == 'rental_property' && !p.inactive && p.property_unit) {
                        this.selectedItems.push({
                            object: 'property_unit',
                            id: p.property_unit.id,
                            name: p.property_unit.full_name || p.property_unit.full_code
                        });
                    }
                });
            }
        }
    }
    invoiceId;
    onInvoice_id(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("invoiceId");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    formId;
    async $$load_formId() {
        return this.$fn.randomElementId();
    }
    searchTerm;
    items;
    selectedItems;
    referenceTypes;
    async $$load_referenceTypes() {
        return [
            {
                type: 'contract',
                text: this.$fn.gettext('Contracts'),
                target: 'contracts',
                dataSource: {
                    name: 'suggest_contract',
                    parameters: {}
                },
                template: '',
            },
            {
                type: 'rental',
                text: this.$fn.gettext('Rentals'),
                target: 'rentals',
                dataSource: {
                    name: 'suggest_rental',
                    parameters: {}
                },
            },
            {
                type: 'client',
                text: this.$fn.gettext('Clients'),
                target: 'tenants',
                dataSource: {
                    name: 'suggest_company',
                    parameters: {
                        role: 'partner'
                    }
                },
            },
            {
                type: 'property',
                text: this.$fn.gettext('Properties'),
                target: 'properties',
                dataSource: {
                    name: 'suggest_property',
                    parameters: {
                        types: 'property,unit'
                    }
                },
            },
        ];
    }
    selectedReferenceType;
    selectedReference;
    async $$load_selectedReference() {
        return _.find(this.referenceTypes, { type: this.selectedReferenceType }) || this.referenceTypes[0];
    }
    ux;
    b_7315092382398562_modalBindings;
    b_7789867021953041_clearable;
    dataMembers = ['formId', 'searchTerm', 'items', 'selectedItems', 'referenceTypes', 'selectedReferenceType', 'selectedReference', 'ux', 'b_7315092382398562_modalBindings', 'b_7789867021953041_clearable'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                formId: null,
                searchTerm: null,
                items: [],
                selectedItems: [],
                referenceTypes: null,
                selectedReferenceType: null,
                selectedReference: null,
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "md",
                },
                b_7789867021953041_clearable: false,
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.$fn.pgettext("Invoice", "Search Reference"),
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_9208_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async act_7789867021953041_setData_9212_getActionArgs($event) {
        return {
            path: "searchTerm",
            value: null,
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async act_7789867021953041_setData_9214_getActionArgs($event) {
        return {
            path: "items",
            value: [],
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async act_7789867021953041_setData_9216_getActionArgs($event) {
        return {
            path: "selectedReferenceType",
            value: $event.data.type,
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async evh_7789867021953041_selected(event, scope) {
        return await this.actions.evh_7789867021953041_selected.executeFromDOM(this, event, scope);
    }
    async act_3468003412020058_script_9218_getActionArgs_value($event) {
        this.onReferenceSelected($event.data);
    }
    async act_3468003412020058_script_9218_getActionArgs($event) {
        return {
            value: () => this.act_3468003412020058_script_9218_getActionArgs_value($event),
        };
    }
    async evh_3468003412020058_optionSelected(event, scope) {
        return await this.actions.evh_3468003412020058_optionSelected.executeFromDOM(this, event, scope);
    }
    async act_6049458597007392_setData_9220_getActionArgs($event) {
        return {
            path: "selectedItems",
            value: (_.remove(this.selectedItems, $event.scope.item), this.selectedItems.slice()),
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async evh_6049458597007392_click(event, scope) {
        return await this.actions.evh_6049458597007392_click.executeFromDOM(this, event, scope);
    }
    async act_1548630417156826_closeComponent_9224_getActionArgs($event) {
        return {
            result: {
                ok: true,
            },
        };
    }
    async act_1548630417156826_request_9222_getActionArgs($event) {
        return {
            operation: "create_invoice_reference",
            data: _.map(this.selectedItems, p => ({ reference_id: p.id })),
            parameters: {
                invoice_id: this.invoiceId,
            },
        };
    }
    async evh_1548630417156826_clickPreventStop(event, scope) {
        return await this.actions.evh_1548630417156826_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async evh_1419464017721962_clickPreventStop(event, scope) {
        return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_9208 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_9208_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_9207 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_9208,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_9207],
        });
        const act_2248226175642056_closeComponent_9210 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_2248226175642056_close_9209 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeComponent_9210,
            event: "close",
            displayName: "closeComponent",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_9209],
        });
        const act_7789867021953041_setData_9212 = new core_1.actions.SetDataAction({
            actionArgs: this.act_7789867021953041_setData_9212_getActionArgs,
            events: [],
        });
        const evh_7789867021953041_selected_9211 = new core_1.actions.EventHandlerImpl({
            action: act_7789867021953041_setData_9212,
            event: "selected",
            displayName: "setData",
        });
        const act_7789867021953041_setData_9214 = new core_1.actions.SetDataAction({
            actionArgs: this.act_7789867021953041_setData_9214_getActionArgs,
            events: [],
        });
        const evh_7789867021953041_selected_9213 = new core_1.actions.EventHandlerImpl({
            action: act_7789867021953041_setData_9214,
            event: "selected",
            displayName: "setData",
        });
        const act_7789867021953041_setData_9216 = new core_1.actions.SetDataAction({
            actionArgs: this.act_7789867021953041_setData_9216_getActionArgs,
            events: [],
        });
        const evh_7789867021953041_selected_9215 = new core_1.actions.EventHandlerImpl({
            action: act_7789867021953041_setData_9216,
            event: "selected",
            displayName: "setData",
        });
        const evh_7789867021953041_selected = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7789867021953041_selected_9211, evh_7789867021953041_selected_9213, evh_7789867021953041_selected_9215],
        });
        const act_3468003412020058_script_9218 = new core_1.actions.ScriptAction({
            actionArgs: this.act_3468003412020058_script_9218_getActionArgs,
            events: [],
        });
        const evh_3468003412020058_optionSelected_9217 = new core_1.actions.EventHandlerImpl({
            action: act_3468003412020058_script_9218,
            event: "optionSelected",
            displayName: "script",
        });
        const evh_3468003412020058_optionSelected = new core_1.actions.EventHandlerGroup({
            handlers: [evh_3468003412020058_optionSelected_9217],
        });
        const act_6049458597007392_setData_9220 = new core_1.actions.SetDataAction({
            actionArgs: this.act_6049458597007392_setData_9220_getActionArgs,
            events: [],
        });
        const evh_6049458597007392_click_9219 = new core_1.actions.EventHandlerImpl({
            action: act_6049458597007392_setData_9220,
            event: "click",
            displayName: "setData",
        });
        const evh_6049458597007392_click = new core_1.actions.EventHandlerGroup({
            handlers: [evh_6049458597007392_click_9219],
        });
        const act_1548630417156826_closeComponent_9224 = new core_1.actions.CloseComponentAction({
            actionArgs: this.act_1548630417156826_closeComponent_9224_getActionArgs,
            events: [],
        });
        const evh_1548630417156826_success_9223 = new core_1.actions.EventHandlerImpl({
            action: act_1548630417156826_closeComponent_9224,
            event: "success",
            displayName: "closeComponent",
        });
        const act_1548630417156826_request_9222 = new core_1.actions.RequestAction({
            actionArgs: this.act_1548630417156826_request_9222_getActionArgs,
            displayName: "submitReferences",
            events: [evh_1548630417156826_success_9223],
        });
        const evh_1548630417156826_clickPreventStop_9221 = new core_1.actions.EventHandlerImpl({
            action: act_1548630417156826_request_9222,
            event: "click.prevent.stop",
            displayName: "submitReferences",
        });
        const evh_1548630417156826_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1548630417156826_clickPreventStop_9221],
        });
        const act_1419464017721962_closeComponent_9226 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_1419464017721962_clickPreventStop_9225 = new core_1.actions.EventHandlerImpl({
            action: act_1419464017721962_closeComponent_9226,
            event: "click.prevent.stop",
            displayName: "closeComponent",
        });
        const evh_1419464017721962_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1419464017721962_clickPreventStop_9225],
        });
        return {
            act_7315092382398562_closeModal_9208,
            evh_7315092382398562_close_9207,
            evh_7315092382398562_close,
            act_2248226175642056_closeComponent_9210,
            evh_2248226175642056_close_9209,
            evh_2248226175642056_close,
            act_7789867021953041_setData_9212,
            evh_7789867021953041_selected_9211,
            act_7789867021953041_setData_9214,
            evh_7789867021953041_selected_9213,
            act_7789867021953041_setData_9216,
            evh_7789867021953041_selected_9215,
            evh_7789867021953041_selected,
            act_3468003412020058_script_9218,
            evh_3468003412020058_optionSelected_9217,
            evh_3468003412020058_optionSelected,
            act_6049458597007392_setData_9220,
            evh_6049458597007392_click_9219,
            evh_6049458597007392_click,
            act_1548630417156826_closeComponent_9224,
            evh_1548630417156826_success_9223,
            act_1548630417156826_request_9222,
            evh_1548630417156826_clickPreventStop_9221,
            evh_1548630417156826_clickPreventStop,
            act_1419464017721962_closeComponent_9226,
            evh_1419464017721962_clickPreventStop_9225,
            evh_1419464017721962_clickPreventStop,
            submitReferences: act_1548630417156826_request_9222,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: String,
    }),
    __metadata("design:type", String)
], InvoiceReferenceSearch.prototype, "invoiceId", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('invoiceId'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], InvoiceReferenceSearch.prototype, "onInvoice_id", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "md",
    }),
    __metadata("design:type", String)
], InvoiceReferenceSearch.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], InvoiceReferenceSearch.prototype, "onSize", null);
InvoiceReferenceSearch = __decorate([
    (0, vue_property_decorator_1.Component)()
], InvoiceReferenceSearch);
exports.default = InvoiceReferenceSearch;
vue_property_decorator_1.Vue.component("InvoiceReferenceSearch", InvoiceReferenceSearch);
